export default "__VITE_PUBLIC_ASSET__301e1c86__"